import React from "react";
// import ClubNameSVG from "./ClubNameSVG";

export default function HeaderDownload({ selectedClub, selectedStudio }) {
  const clubName = selectedClub?.name?.split(" - ")[1].toUpperCase() || "CLUB";
  const studioName =
    selectedStudio?.name?.split(" - ")[0].toUpperCase() || "STUDIO";
  const monthYear = new Date()
    .toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    })
    .toUpperCase();

  return (
    <div className="header-download-container">
      {/* Atas */}
      <div className="header-download-above-group">
        <div
          className="d-flex flex-column"
          // style={{ display: "flex", alignItems: "center", gap: "24px" }}
        >
          <span className="header-download-club-name">{clubName}</span>
          {selectedStudio && (
            <span className="header-download-studio-name">
              {">> " + studioName}
            </span>
          )}
        </div>

        <div className="header-download-logo">
          <img
            src={`/images/logo-stride.png`}
            alt="logo"
            style={{ width: "max-content", height: "80px" }}
          />
        </div>
      </div>
      {/* Bawah */}
      <div className="header-download-bellow-container">
        <div></div>
        <div className="header-download-bellow-group">
          <span className="header-download-badge-label">CLASS SCHEDULE</span>
          <div className="header-download-badge-month">
            <span className="header-download-badge-month-text">
              {monthYear}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
